import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUnreadMessagesAction } from 'store/message/messageActions';
import InputContainer from '../InputContainer';
import ScrollContainer from 'components/ScrollContainer';
import ChatInput from './ChatInput';
import ChatMessage from './ChatMessage';

export default function Chat() {
  const { name, messages } = useSelector(({ chime, message }) => ({
    name: chime.name,
    messages: message.messages,
  }));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setUnreadMessagesAction(0));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <ScrollContainer scrollOnUpdate>
        {messages.map((message, idx) => (
          <ChatMessage
            data-testid="message-box"
            id={`chat-message-render-${idx}`}
            key={idx}
            isMe={name.toLowerCase() === message?.payload?.name?.toLowerCase()}
            message={message}
          />
        ))}
      </ScrollContainer>

      <InputContainer>
        <ChatInput />
      </InputContainer>
    </>
  );
}
